import { Link } from 'react-router-dom';

export default function CtaBanner() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=abstract%20dark%20teal%20and%20slate%20gradient%20background%20with%20subtle%20geometric%20circuit%20patterns%2C%20modern%20technology%20aesthetic%2C%20deep%20rich%20colors%2C%20no%20people%2C%20clean%20professional%20design&width=1200&height=400&seq=cta1&orientation=landscape"
            alt="CTA background"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 to-emerald-950/80"></div>

          <div className="relative px-8 md:px-16 py-14 text-center">
            <span className="text-xs font-semibold uppercase tracking-widest text-emerald-400 mb-4 block">
              Free to Get Started
            </span>
            <h2
              className="text-3xl md:text-4xl font-extrabold text-white mb-4"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Ready to Achieve Your Best Grade?
            </h2>
            <p className="text-slate-300 text-base max-w-xl mx-auto mb-8">
              Join over 12,000 UK students already using GCSE Computing to revise smarter and score higher in their Computer Science exams.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/login?tab=register"
                className="bg-emerald-700 hover:bg-emerald-600 text-white font-semibold px-8 py-3.5 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-sm"
              >
                Create Free Account
              </Link>
              <Link
                to="/syllabus"
                className="border border-white/30 hover:border-white/60 text-white font-semibold px-8 py-3.5 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-sm"
              >
                Browse Syllabus
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
